
import 'highlight.js/styles/dark.css'
 export default { 
    name : 'Skips',
    methods: {
      onClickLink (href, isExternal) {
        this.$emit('click-link', href, isExternal)
      },
    },
  }